import useGoogleMaps from 'src/hooks/useGoogleMaps';

/**
 * Thin wrapper kept for the Track screens that already consume this API.
 *
 * The real loading now lives in the shared useGoogleMaps hook. This used to assign
 * window.initMap itself, which clobbered any other component waiting on the same global callback
 * — with the script no longer preloaded at boot, that race would drop the "script ready" signal.
 *
 * `isReady`   — window.google.maps.places is available; render the autocomplete fields.
 * `isLoading` — script requested, not usable yet; disable the fields meanwhile.
 */
export const useGoogleMapsScript = () => {
    const { isReady } = useGoogleMaps();

    return { isReady, isLoading: !isReady };
};

export default useGoogleMapsScript;
